import React, { PureComponent } from "react";
import SockJsClient from "react-stomp";
import UrlFactory from "../../../services/UrlFactory";
import PartySession from "../../../session/PartySession";
import WebSocketUtils from "../../../utils/WebSocketUtils";

class WebSocketClientContainer extends PureComponent {
  constructor(props) {
    super(props);
    this.urlFactory = new UrlFactory();
  }

  componentDidMount() {
    WebSocketUtils.checkWebSocketSupport();
  }

  constructTopicPath = topic => {
    if (topic.includePartyId) {
      return `/topic/${topic.name}/${PartySession.getPartyId()}`;
    } else {
      return `/topic/${topic.name}`;
    }
  };

  constructTopics = () => {
    const selectedTopics = this.props.topics;
    const constructedTopics = [];
    if (selectedTopics) {
      selectedTopics.forEach(selectedTopic => {
        constructedTopics.push(this.constructTopicPath(selectedTopic));
      });
    }
    return constructedTopics;
  };

  render() {
    return (
      <SockJsClient
        url={this.urlFactory.websocketUrl()}
        topics={this.constructTopics()}
        onMessage={this.props.onMessage}
      />
    );
  }
}
export default WebSocketClientContainer;
